import { render } from "./Slider.vue?vue&type=template&id=285cbe02&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=285cbe02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-285cbe02"

export default script